/**
 * Internal ops document_correction info_requested writer permissions (V0).
 * Colon-form InternalEntity catalog keys — NOT portal underscore customer caps.
 */

export const DOCUMENT_CORRECTION_OPS_READ_PERMISSION = 'document_correction:read' as const;
export const DOCUMENT_CORRECTION_OPS_REQUEST_INFO_PERMISSION =
  'document_correction:request_info' as const;

export const DOCUMENT_CORRECTION_OPS_INFO_REQUEST_PERMISSIONS = [
  DOCUMENT_CORRECTION_OPS_READ_PERMISSION,
  DOCUMENT_CORRECTION_OPS_REQUEST_INFO_PERMISSION,
] as const;

export type DocumentCorrectionOpsInfoRequestPermission =
  (typeof DOCUMENT_CORRECTION_OPS_INFO_REQUEST_PERMISSIONS)[number];

export function isDocumentCorrectionOpsInfoRequestPermission(
  permission: string
): permission is DocumentCorrectionOpsInfoRequestPermission {
  return (DOCUMENT_CORRECTION_OPS_INFO_REQUEST_PERMISSIONS as readonly string[]).includes(
    permission
  );
}

export function hasDocumentCorrectionOpsReadPermission(
  permissions: readonly string[] | undefined
): boolean {
  if (!permissions?.length) return false;
  const granted = new Set(permissions);
  return (
    granted.has(DOCUMENT_CORRECTION_OPS_READ_PERMISSION) ||
    granted.has(DOCUMENT_CORRECTION_OPS_REQUEST_INFO_PERMISSION) ||
    granted.has('document_correction:review') ||
    granted.has('system:admin')
  );
}

export function hasDocumentCorrectionOpsRequestInfoPermission(
  permissions: readonly string[] | undefined
): boolean {
  if (!permissions?.length) return false;
  const granted = new Set(permissions);
  return (
    granted.has(DOCUMENT_CORRECTION_OPS_REQUEST_INFO_PERMISSION) || granted.has('system:admin')
  );
}
